import { logTransaction } from '../../common/log';
import { LogType } from '../../models/log.model';

// This upgrade moves most of the data out of the SQLite database and into the
// native storage key/value storage. As a result, it is necessary that the
// authentication and other data is moved.

const upgrade = async () => {
  logTransaction(LogType.Internal, '[SQLITE]: Upgrade version 0001 no longer required');
  return;
};

export default upgrade;